module.exports = __webpack_public_path__ + "media/images/pin-new-store-a16b7afe31cf80b4ebccdc61aadccb40.png";